export const SERVICE_COLOR = '#FF6E2E';
export const SERVICE_LIGHT = '#ff6410';
export const SERVICE_DARK = '#ff3c10';

export const LIGHT_GRAY = '#E0E0E0';
